import React, { useState } from 'react'
import classes from "./styles/diceroller.module.css";
import { Helmet } from 'react-helmet';
import { FullWidthWiraaAds } from '../../../common/Ads/FullWidthWiraaAds';
import TitleSection from '../../../common/TitleSection';
import styles from "../../../ContentStyling.module.css";

const OnlineDiceRoller = () => {
    const [dice, setDice] = useState(1);
    const [rolling, setRolling] = useState(false);

    const rollDice = () => {
        if (rolling) return;

        setRolling(true);
        let rollCount = 0;
        
        const interval = setInterval(() => {
            setDice(Math.floor(Math.random() * 6) + 1);
            rollCount++;

            if (rollCount > 40) {
                clearInterval(interval);
                setDice(Math.floor(Math.random() * 6) + 1); // Final random face
                setRolling(false);
            }
        }, 50);
    };


  return (
    <div className={classes.page}>
      <Helmet>
                <title>Online Dice Roller - Wiraa tools</title>
                <meta name="description" content="Roll a dice online with our free dice roller. Simulate rolling a 6-sided die with animation!" />
        </Helmet>
    <div className={classes.container}>
      <TitleSection
      icon="https://cdn-icons-png.flaticon.com/128/7262/7262385.png"
      title="Online Dice Roller"
      subTitle="Virtual Dice, Real Fun – Roll Anytime, Anywhere!"
      />
      <div className={classes.innerCon}>
      <div className={classes.diceCon}>
            <div className={classes.dice}>
                {["⚀", "⚁", "⚂", "⚃", "⚄", "⚅"][dice - 1]}
            </div>
        </div>
        
        <div className={classes.btnCon}>
            <button className={classes.convertBtn} onClick={rollDice}>Roll</button>
        </div>
      </div>

      <div className={classes.ads}>
        <FullWidthWiraaAds/>
     </div>

      <div className={styles.contentContainer}>
      </div>
    </div>
    </div>
  )
}

export default OnlineDiceRoller;
